module.exports = __webpack_public_path__ + "static/img/road2.285e1dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/road2.png
// module id = vGBG
// module chunks = 1